import React from 'react';
import PropTypes from 'prop-types';

import { Collapse, TableCell, TableRow } from '@mui/material';

import OnEditIcon from '../../../../icons/OnEditIcon';

import T2DRHealthDataRowDetails from './T2DRHealthDataRowDetails';

import table from '../../../../commonStyles/tables.module.css';
import local from './t2drHealthData.module.css';

const styles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const T2DRHealthDataRow = ({ row, isDisabled, onEdit, toggleDropdown, openId }) => {
    const onToggleDropdown = () => toggleDropdown(openId === row.id ? '' : row.id);

    return (
        <>
            <TableRow
                key={row.id}
                hover
                className={table.basicRowStripes}
                onClick={onToggleDropdown}>
                <TableCell>
                    {' '}
                    {row.tdrConsumption || <span className={local.emptyRow1}> - </span>}{' '}
                </TableCell>
                <TableCell>
                    {' '}
                    {row.rescuePackageOffered || <span className={local.emptyRow2}> - </span>}{' '}
                </TableCell>
                <TableCell>
                    {' '}
                    {row.rescuePackageDeclinedReason || (
                        <span className={local.emptyRow2}> - </span>
                    )}{' '}
                </TableCell>
                <TableCell>
                    {' '}
                    {row.rescuePackageType || <span className={local.emptyRow3}> - </span>}{' '}
                </TableCell>
                <TableCell>
                    {' '}
                    {row.rescuePackageMedicationConfirmation || (
                        <span className={local.emptyRow3}> - </span>
                    )}{' '}
                </TableCell>
                <TableCell> {row.tdrDaysMissed || ' - '} </TableCell>
                <TableCell align="right">
                    <OnEditIcon onEdit={(e) => onEdit(e, row)} active={!isDisabled} />
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={styles} colSpan={7}>
                    <Collapse in={openId === row.id} timeout="auto" unmountOnExit>
                        <T2DRHealthDataRowDetails row={row} onClose={onToggleDropdown} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

T2DRHealthDataRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    onEdit: PropTypes.func,
    toggleDropdown: PropTypes.func,
    openId: PropTypes.string
};

export default T2DRHealthDataRow;
